export const environment = {
  production: false,
  apiBaseUrl: 'https://surveyapi-dev.cieneguillariberadelrio.com/api/v1',
  survey: {
    propertyCode: 'ribera-cieneguilla',
    useEntrySession: false,
  },
};
